import axios from 'axios';

export const getComponentS = (org_id?: number) => {
  let theQuery='';
  if(org_id){
    theQuery=`org_id=${org_id}`
  }
  return axios.get(
    process.env.REACT_APP_API_GLOBAL_URL +
      `department/app-component?${theQuery}`
  );
};
export const AddAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/app-component/create`,
    obj,
    { headers }
  );
};

export const EditAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/app-component/update`,
    obj,
    { headers }
  );
};

export const DeleteAppComponent = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL + `department/app-component/delete`,
    obj,
    { headers }
  );
};
